<template>
  <AppCollapse :initiallyOpen="initiallyOpen" :forceVshow="forceVshow">
    <template #header="{ toggle, isOpen }">
      <div
        class="border-bottom common-accordion px-3"
        :class="headerClass && { [headerClass]: true }"
        @click="toggle"
      >
        <div
          class="d-flex justify-content-between align-items-center"
          data-test="common-accordion"
        >
          <AppIcon v-if="togglePosition === 'left'" :name="isOpen ? 'expand_less' : 'expand_more'" />
          <div class="flex-1">
            <slot name="header" />
          </div>
          <AppIcon v-if="togglePosition === 'right'" :name="isOpen ? 'expand_less' : 'expand_more'" />
        </div>
      </div>
    </template>

    <template #body>
      <slot name="content" />
    </template>
  </AppCollapse>
</template>

<script>
export default {
  props: {
    initiallyOpen: {
      type: Boolean,
      default: false,
    },
    forceVshow: {
      type: Boolean,
      default: false,
    },
    headerClass: {
      type: String,
      default: '',
    },
    togglePosition: {
      type: String,
      default: 'right',
    },
  },
}
</script>

<style lang="css" scoped>
  .common-accordion:hover {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.03);
  }

  .diff-change-removed {
    background: #fccac7 !important;
    color: #7f231c;
  }

  .diff-change-added {
    background: #cde9ce !important;
    color: #285b2a;
  }
</style>
